<app-page-heading [key]="(mode === DisplayMode.Creation ? 'user-dashboard.users.plant-managers.form.page-title.creation' : 'user-dashboard.users.plant-managers.form.page-title.update')" [subheadingIcon]="'fa fa-user-plus'"></app-page-heading>

<app-user-form #userForm [user]="user" [mode]="mode" [userTypeLabelKey]="'user-dashboard.groups.plant-manager'"
               [create]="onCreate" [update]="onUpdate" [showPlants]="true" [plants]="plants"
               [remove]="onDelete" [block]="onToggleBlocking"
               [unblockIp]="onUnblockIp"
               (changePassword)="changePassword($event)"
               (afterCreate)="goToPlantManagerList()"
               (afterDelete)="goToPlantManagerList()"
>
</app-user-form>
